import React from "react";
import BEMHelper from "react-bem-helper";
import { useAppDispatch } from "@/hooks";

// Elements
import ShowMoreText from "@/components/elements/ShowMoreText";
import { Button } from "bokamera-embedded-ui";
import { selectArticle } from "@/reducers/article";
import { Trans } from "@lingui/macro";

import { Article as ArticleType, CompanyType, Configuration } from "@/types";

import "./BoughtArticle.css";

interface Props {
  article: ArticleType;
  company: CompanyType;
  configuration: Configuration
  hideSelect?: boolean
}

const c = new BEMHelper({
  name: "Article",
});

const ArticleDetails: React.FC<Props> = ({ article, company, configuration, hideSelect }) => {

  const dispatch = useAppDispatch();
  return (
    <>
      {!configuration.hideServiceImage && (
        <div {...c("imageContainer")}>
          {article.ImageUrl || company?.LogoType ? (
            <img
              // @ts-ignore
              src={article.ImageUrl || company?.LogoType}
              {...c("image")}
              alt={article.Name}
            />
          ) : (
            <div
              {...c("imagePlaceholder")}
              style={{ backgroundColor: "rgb(240, 240, 235)" }}
            />
          )}
        </div>
      )}
      <div {...c("main")}>
        <div {...c("content")}>
          <h4 {...c("title")}>{article.Name}</h4>
          {article.Description ? (
            <p>
              <ShowMoreText>{article.Description}</ShowMoreText>
            </p>
          ) : null}
        </div>
        <div {...c("divider")} />
        <div {...c("actionBox")}>
          <div {...c("priceContainer")} data-testid="service-prices">
            <div {...c("price")}>
              {/* @ts-ignore */}
              <span {...c("priceValue")}>
                {article.Price}
                {article.PriceSign}
              </span>
            </div>
          </div>
          {!hideSelect && (
            <Button
              {...c("select")}
              primary
              outline
              onClick={() => dispatch(selectArticle({ article }))}
            >
              <Trans id="Article.buy"></Trans>
            </Button>
          )}
        </div>


      </div>
    </>
  );
};

export default ArticleDetails;
